/**
 * @generated SignedSource<<ea1d68cbf02643e2ccf6c2858ea4f944>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type InsertColumnButton$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer_savedViewId">;
  readonly " $fragmentType": "InsertColumnButton";
};
export type InsertColumnButton$key = {
  readonly " $data"?: InsertColumnButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"InsertColumnButton">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "InsertColumnButton",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ColumnConfigWithContainer_savedViewId"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "6ab7fc38f11e427975f678187d262f14";

export default node;
